import { render, staticRenderFns } from "./AttendanceCourseIndex.vue?vue&type=template&id=2e152e5e&scoped=true&"
import script from "./AttendanceCourseIndex.vue?vue&type=script&lang=js&"
export * from "./AttendanceCourseIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e152e5e",
  null
  
)

export default component.exports